import { getTranslation } from 'common/react/utils/translations';

/**
 * Generates the round specific text for the TBC cards on the bracket.
 *
 * @param {string} finalsStage - One of semiFinal, preliminary and grandFinal.
 * @param {number} index - The index to determine where the card
 * @param {boolean} hasWildcard - Whether the wildcard round exists or not, to determine the text for the qualifying finals.
 *
 * @returns {object} An object with topText, bottomText and matchName to be used
 * across the card.
 */
export function generateTBCCardText(finalsStage, index, hasWildcard = false) {
    switch (finalsStage) {
        case 'wildcard':
            if (index === 0) {
                return {
                    topText: getTranslation(
                        'label.ladderPredictor.finalsGame.7thPlaced'
                    ),
                    bottomText: getTranslation(
                        'label.ladderPredictor.finalsGame.10thPlaced'
                    ),
                    roundName: getTranslation(
                        'label.ladderPredictor.finalsGame.Wildcard1'
                    )
                };
            }
            if (index === 1) {
                return {
                    topText: getTranslation(
                        'label.ladderPredictor.finalsGame.8thPlaced'
                    ),
                    bottomText: getTranslation(
                        'label.ladderPredictor.finalsGame.9thPlaced'
                    ),
                    roundName: getTranslation(
                        'label.ladderPredictor.finalsGame.Wildcard2'
                    )
                };
            }
        case 'qualifying':
            if (index === 0) {
                return {
                    topText: getTranslation(
                        'label.ladderPredictor.finalsGame.1stPlaced'
                    ),
                    bottomText: getTranslation(
                        'label.ladderPredictor.finalsGame.4thPlaced'
                    ),
                    roundName: getTranslation(
                        'label.ladderPredictor.finalsGame.1stQualifyingFinal'
                    )
                };
            }
            if (index === 1) {
                return {
                    topText: getTranslation(
                        'label.ladderPredictor.finalsGame.5thPlaced'
                    ),
                    bottomText: hasWildcard ? getTranslation(
                        'label.ladderPredictor.finalsGame.LowestRankedWFWinner'
                    ) : getTranslation(
                        'label.ladderPredictor.finalsGame.8thPlaced'
                    ),
                    roundName: getTranslation(
                        'label.ladderPredictor.finalsGame.1stEliminationFinal'
                    )
                };
            }
            if (index === 2) {
                return {
                    topText: getTranslation(
                        'label.ladderPredictor.finalsGame.6thPlaced'
                    ),
                    bottomText: hasWildcard ? getTranslation(
                        'label.ladderPredictor.finalsGame.HighestRankedWFWinner'
                    ) : getTranslation(
                        'label.ladderPredictor.finalsGame.7thPlaced'
                    ),
                    roundName: getTranslation(
                        'label.ladderPredictor.finalsGame.2ndEliminationFinal'
                    )
                };
            }
            if (index === 3) {
                return {
                    topText: getTranslation(
                        'label.ladderPredictor.finalsGame.2ndPlaced'
                    ),
                    bottomText: getTranslation(
                        'label.ladderPredictor.finalsGame.3rdPlaced'
                    ),
                    roundName: getTranslation(
                        'label.ladderPredictor.finalsGame.2ndQualifyingFinal'
                    )
                };
            }
        case 'semiFinal':
            if (index === 0) {
                return {
                    topText: getTranslation(
                        'label.ladderPredictor.finalsGame.LoserOfQF1'
                    ),
                    bottomText: getTranslation(
                        'label.ladderPredictor.finalsGame.WinnerOfEF1'
                    ),
                    roundName: getTranslation(
                        'label.ladderPredictor.finalsGame.1stSemiFinal'
                    )
                };
            }
            return {
                topText: getTranslation(
                    'label.ladderPredictor.finalsGame.LoserOfQF2'
                ),
                bottomText: getTranslation(
                    'label.ladderPredictor.finalsGame.WinnerOfEF2'
                ),
                roundName: getTranslation(
                    'label.ladderPredictor.finalsGame.2ndSemiFinal'
                )
            };
        case 'preliminary':
            if (index === 0) {
                return {
                    topText: getTranslation(
                        'label.ladderPredictor.finalsGame.WinnerOfQF1'
                    ),
                    bottomText: getTranslation(
                        'label.ladderPredictor.finalsGame.WinnerOfSF2'
                    ),
                    roundName: getTranslation(
                        'label.ladderPredictor.finalsGame.1stPreliminaryFinal'
                    )
                };
            }
            return {
                topText: getTranslation(
                    'label.ladderPredictor.finalsGame.WinnerOfQF2'
                ),
                bottomText: getTranslation(
                    'label.ladderPredictor.finalsGame.WinnerOfSF1'
                ),
                roundName: getTranslation(
                    'label.ladderPredictor.finalsGame.2ndPreliminaryFinal'
                )
            };
        default:
            return {
                topText: getTranslation(
                    'label.ladderPredictor.finalsGame.WinnerOfPF1'
                ),
                bottomText: getTranslation(
                    'label.ladderPredictor.finalsGame.WinnerOfPF2'
                ),
                roundName: getTranslation(
                    'label.ladderPredictor.columns.grandFinal'
                )
            };
    }
}
